import React, { useEffect, useRef, useState } from 'react';
import { Trial } from './Trial';
import { TrialModal } from '~/common/components/TrialModal';
import { gtagEnvelope } from '~/common/util/gtagEnvelope';
import { MODAL_TYPES } from '~/common/consts';
import Chevy from './Modals/Chevy';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';
import { ModalContentProvider } from '~/common/provider/ModalContentProvider';
import Unified from './Modals/Unified';

const ModalShell = () => {
  const [activeModal, setActiveModal] = useState<string>();
  const prevModalRef = useRef<string>();

  useEffect(() => {
    window.TrialForm = {
      open: (type: string) => setActiveModal(type),
    };
  }, []);

  useEffect(() => {
    if (activeModal) {
      gtagEnvelope('event', `${activeModal} Trial Modal`, {
        modal_event: 'Load',
      });
    } else if (prevModalRef.current) {
      gtagEnvelope('event', `${prevModalRef.current} Trial Modal`, {
        modal_event: 'Close',
      });
    }
    prevModalRef.current = activeModal;
  }, [activeModal]);

  if (!activeModal) {
    return null;
  }

  return (
    <TrialModal onCloseCallBack={() => setActiveModal(null)} customStyles={MODAL_TYPES.UNIFIED}>
      {activeModal === MODAL_TYPES.CHEVY ? (
        <ModalContentProvider contentId="6bdc41f3-910e-4115-803e-c22686bb29dc">
          <Chevy />
        </ModalContentProvider>
      ) : activeModal === MODAL_TYPES.UNIFIED ? (
        <Unified />
      ) : (
        <TrialContentProvider>
          <Trial modalType={activeModal} />
        </TrialContentProvider>
      )}
    </TrialModal>
  );
};

export default ModalShell;
